<template>
  <div class="app-section__header-container">
    <app-divider />
    <div class="app-section__header-title">
      <slot>
        Section Title
      </slot>
    </div>
  </div>
</template>

<script>
import AppDivider from './AppDivider'

export default {
  name: 'AppSectionHeader',
  components: {
    AppDivider
  }
}
</script>

<style scoped>
.app-section__header-container {
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-direction: column;
  align-content: center;
  justify-content: flex-end;
  margin-bottom: 1rem;
}

.app-section__header-title {
  margin-bottom: 0.25rem;
  font-family: "Avenir-Heavy";
  font-size: 1.5rem;
  color: #332924;
  letter-spacing: 0;
  text-align: center;
}
</style>
